<template>
  <div id="bom-main-info">
    <div class="bom-main--header">
      <ul v-if="!loading">
        <li v-if="bom">{{ $t('bom_tool.name') }}: <strong :class="readonly ? 'readonly' : 'highlight'">{{ bom.name }}</strong></li>
        <li v-if="bom && bom.manufacturer_part">{{ $t('bom_tool.part_number') }}: <strong :class="readonly ? 'readonly' : 'highlight'"><a @click="handlePartNumberClick">{{ bom.manufacturer_part.part_identity ? bom.manufacturer_part.part_identity.part_number : 'N/A' }}</a></strong></li>
        <li v-if="bomVersion && !bom.is_draft">Version: <strong :class="readonly ? 'readonly' : 'highlight'">{{ bomVersion }}</strong></li>
        <li v-else>{{ $t('bom_tool.current_state') }}: <strong :class="readonly ? 'readonly' : 'highlight'">{{ $t('bom_tool.editing') }}</strong></li>
        <li><Button data-test-id="edit-bom-info-btn" type="text" icon="md-create" @click="showBomInfoDrawer"></Button></li>
        <li>
          <Button size="small" type="primary" @click="switch2Current" title="Switch to current state of editable a BOM" :disabled="!readonly">current</Button>
        </li>
      </ul>
    </div>
    <Span fix size="large" v-if="loading">
      <slot name="loading"></slot>
    </Span>
    <Drawer data-test-id="edit-bom-info-drawer" :title="$t('bom_tool.edit_bom_info')" v-model="bomInfoDrawer" :mask-closable="false" width="560">
      <BomForm ref="bomEditForm" :bomMain="bom" @bomSaved="handleBomSaved" :readonly="readonly"></BomForm>
    </Drawer>
  </div>
</template>

<script>
import BomForm from './forms/bom-form'
export default {
  name: 'BomMainInfo',
  components: {
    BomForm
  },
  props: {
    bom: {
      type: Object,
      default () {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      bomInfoDrawer: false
    }
  },
  computed: {
    bomVersion: function () {
      return this.bom ? this.bom.version : ''
    }
  },
  methods: {
    handleBomSaved(bom, close) {
      this.bom = Object.assign(bom)
      this.bomInfoDrawer = !close
    },
    handlePartNumberClick () {
      if (this.bom.manufacturer_part) {
        const router = this.$router.resolve({ name: `menu.${this.bom.manufacturer_part.component_type}.edit`, params: { partId: this.bom.manufacturer_part_id } })
        window.open(router.href, '_blank')
      }
    },
    showBomInfoDrawer() {
      this.bomInfoDrawer = true
      this.$refs.bomEditForm.initBom(this.bom)
    },
    switch2Current () {
      this.$router.push({ name: 'menu.bom.view', params: { bomId: this.bom.id } })
    }
  }
}
</script>

<style lang="less" scoped>
.bom-main--header {
  height: 51px;
  ul {
    display: inline-block; line-height: 51px;
    list-style: none;
    li { float: left; width: auto; margin-right: 15px; }
  }

  .highlight { color: #2d8cf0; }
  .readonly { color: #c5c8ce; }
}
</style>
